import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './app/core/environment';

/*
 * v1.6.738 — Enable Angular production mode for all non-local
 * deployments.
 *
 * Pre-fix this bundle ran in DEVELOPMENT mode at runtime regardless
 * of build configuration. Two root causes:
 *
 *   1. `enableProdMode()` was never called anywhere.
 *   2. There was no `environment.prod.ts` and no `fileReplacements`
 *      in angular.json, so even `ng build --configuration=production`
 *      shipped a bundle with `environment.production === false`.
 *
 * Dev mode runs change detection TWICE per cycle plus
 * ExpressionChangedAfterItHasBeenCheckedError verification. For a
 * heavy template (565-line label template editor with 95 bindings),
 * that's 5-10x slower view instantiation than production. The
 * operator-reported "label-templates editor freeze on /new" was
 * surfaced by this: dev-mode-only console warning ("Angular is
 * running in development mode") was visible in the operator's
 * DevTools at the production URL, plus the perceived freeze matched
 * the timing of dev-mode CD overhead on the heavy editor template.
 *
 * Two defenses, intentionally redundant:
 *
 *   1. `environment.production` — set true in environment.prod.ts,
 *      swapped in via fileReplacements when build configuration is
 *      production. This is the orthodox Angular path.
 *
 *   2. Hostname check — if the page is loaded from anything other
 *      than localhost / 127.0.0.1 / 0.0.0.0, force production mode.
 *      This is the safety net: even if a deploy pipeline runs the
 *      WRONG build configuration or someone reverts the angular.json
 *      file replacement, the live tenant-facing URLs still get
 *      production mode at runtime.
 *
 * Local development (ng serve at localhost:4200) keeps dev mode, so
 * error overlays / source maps / strict CD checks continue to work
 * for developers.
 */
const isLocalDev = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname);
if (environment.production || !isLocalDev) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

